import _ from 'lodash';

import Communicator from 'models/communicator';
import Factory from 'factories/all';

export default function createIncomingTweetItem(incomingTweet, agent) {
  return Factory.build(
    'TwitterItem',
    _.assign({}, incomingTweet.content, {
      initiator: {
        type: Communicator.CUSTOMER,
        id: incomingTweet.customerId,
      },
    })
  );
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/create_incoming_tweet_item.js